let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hri9L")).then(() => parcelRequire('b89xc'));